exports = module.exports = require("../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._39TNOizA7GSChx6_1VUVOs{width:100%;overflow:auto}html[dir] ._39TNOizA7GSChx6_1VUVOs{margin:17px;padding:0 3px}._3JIkRM5v2MYBW1hHK0szLg{font-size:20px;font-weight:600;color:\"[theme:neutralPrimary, default:#333333]\"}html[dir] ._3JIkRM5v2MYBW1hHK0szLg{margin-bottom:24px;padding-bottom:19px;border-bottom:1px solid \"[theme:neutralLight, default:#eaeaea]\"}", ""]);
// Exports
exports.locals = {
	"container": "_39TNOizA7GSChx6_1VUVOs",
	"fileProvidersToAddContainer": "_3JIkRM5v2MYBW1hHK0szLg"
};